import React, { useEffect, useRef, useState } from "react";
import { Check, Copy, ArrowUpRight } from "lucide-react";
import { Button } from "../ui/button";
import { brand } from "../../mock";

export const VipIntro = () => {
  const [copyState, setCopyState] = useState("idle");
  const timer = useRef(null);
  useEffect(() => () => clearTimeout(timer.current), []);

  const copyCode = async () => {
    clearTimeout(timer.current);
    try {
      await navigator.clipboard.writeText(brand.affiliateCode);
      setCopyState("copied");
    } catch {
      setCopyState("error");
    }
    timer.current = setTimeout(() => setCopyState("idle"), 3000);
  };

  return (
    <section className="vip-intro glass" aria-labelledby="vip-title" data-testid="vip-intro">
      <div className="vip-intro-copy">
        <h1 id="vip-title" className="rewards-page-title text-4xl sm:text-5xl" data-testid="vip-title">
          VIP <span>Rewards</span>
        </h1>
        <p data-testid="vip-description">
          Monthly competitions, weekly lossback and level-up rewards on Stake.{" "}<br className="hidden sm:block" />
          A little extra, made for the GreenVenom community.
        </p>
      </div>
      <div className="vip-intro-actions">
        <div className="vip-copy-wrap">
          <Button variant="outline" onClick={copyCode} className="vip-code-button" data-testid="vip-copy-code" aria-label={`Copy affiliate code ${brand.affiliateCode}`}>
            <span className="vip-code-label">Code:</span>
            <span data-testid="vip-affiliate-code">{brand.affiliateCode}</span>
            {copyState === "copied" ? <Check size={16} /> : <Copy size={16} />}
          </Button>
          <span role="status" aria-live="polite" className={`vip-copy-status ${copyState === "error" ? "vip-copy-error" : ""}`} data-testid="vip-copy-status">
            {copyState === "copied" ? "Code copied" : copyState === "error" ? "Couldn't copy. Select the code to copy manually." : ""}
          </span>
        </div>
        <Button asChild className="vip-signup-button">
          <a href="https://stake.com/?c=GreenVenom" target="_blank" rel="noopener noreferrer" data-testid="vip-signup-link">
            Sign Up <ArrowUpRight size={17} aria-hidden="true" />
          </a>
        </Button>
      </div>
    </section>
  );
};